@use '../styles/tokens' as *;

.modal {
  position: fixed;
  inset: 0;
  z-index: 202;
  background-color: rgba($black, 0.5);
}

.content {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 500px;
  min-height: 150px;
  padding: 25px 30px;
  border-radius: 4px;
  background-color: $white;
  box-shadow: 0 4px 20px rgba(28, 28, 28, 0.3);
  transform: translate(-50%, -50%);
}

.close {
  position: absolute;
  top: 28px;
  right: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: none;
  color: $black;
  cursor: pointer;
}
.closeIcon {
  width: 16px;
  height: 16px;
}
